var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgFindCompany = function SvgFindCompany(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 45.65 47.32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".corporate-findcompany-1{fill:#353535;}.corporate-findcompany-2{fill:url(#radial-gradient);}.corporate-findcompany-3{fill:#fff;}.corporate-findcompany-4{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: -279.38,
    cy: 420.48,
    r: 1,
    gradientTransform: "matrix(82.12, 58.43, 58.43, -82.12, -1639.1, 50847.37)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f11e37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b10015"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 7.72,
    y1: 36.61,
    x2: 35.82,
    y2: 18.04,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 51.69)",
    xlinkHref: "#radial-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "corporate-findcompany-1",
    d: "M39.14,4.37A.89.89,0,0,0,40,3.48V2.37a.89.89,0,1,0-1.78,0V3.48A.89.89,0,0,0,39.14,4.37Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "corporate-findcompany-1",
    d: "M31.55,28.56,43.3,40.31a2.55,2.55,0,0,1-3.61,3.61L27.94,32.17Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "corporate-findcompany-1",
    d: "M31.55,28.56l-3.61,3.61L30.81,35l3.61-3.61Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "corporate-findcompany-2",
    d: "M35.68,18.58a17.1,17.1,0,1,0-17.1,17.1A17.11,17.11,0,0,0,35.68,18.58Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "corporate-findcompany-3",
    d: "M18.58,31.4A12.82,12.82,0,1,0,5.75,18.58,12.82,12.82,0,0,0,18.58,31.4Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "corporate-findcompany-4",
    d: "M20.83,18.21H16.32a5.22,5.22,0,0,0-5.22,5.22v.46h15v-.46A5.23,5.23,0,0,0,20.83,18.21Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "corporate-findcompany-3",
    d: "M18.58,10.27a3.39,3.39,0,0,0-3.39,3.39v1.16a3.39,3.39,0,1,0,6.77,0V13.66A3.38,3.38,0,0,0,18.58,10.27Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "corporate-findcompany-1",
    d: "M18.58,4.87A13.71,13.71,0,1,0,32.29,18.58,13.73,13.73,0,0,0,18.58,4.87Zm0,25.64A11.93,11.93,0,1,1,30.51,18.58,11.95,11.95,0,0,1,18.58,30.51Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "corporate-findcompany-1",
    d: "M22,17.42a4.27,4.27,0,0,0,.88-2.6V13.66a4.28,4.28,0,1,0-8.55,0v1.16a4.21,4.21,0,0,0,.89,2.6,6.14,6.14,0,0,0-5,6v.46a.88.88,0,0,0,.89.89h15a.89.89,0,0,0,.89-.89v-.46A6.14,6.14,0,0,0,22,17.42Zm-5.89-3.76a2.5,2.5,0,1,1,5,0v1.16a2.5,2.5,0,1,1-5,0ZM12,23a4.34,4.34,0,0,1,4.31-3.9h4.51A4.34,4.34,0,0,1,25.15,23Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "corporate-findcompany-1",
    d: "M39.42,9.85A.89.89,0,0,0,40.31,9V7.85a.89.89,0,0,0-1.78,0V9A.89.89,0,0,0,39.42,9.85Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "corporate-findcompany-1",
    d: "M41.52,6.65h1.11a.9.9,0,0,0,0-1.79H41.52a.9.9,0,0,0,0,1.79Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "corporate-findcompany-1",
    d: "M36.22,6.65h1.1a.9.9,0,0,0,0-1.79h-1.1a.9.9,0,1,0,0,1.79Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "corporate-findcompany-1",
    d: "M6.11,37.29a.89.89,0,0,0-.89.89v1.1a.89.89,0,1,0,1.78,0v-1.1A.89.89,0,0,0,6.11,37.29Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "corporate-findcompany-1",
    d: "M6.1,42.59a.89.89,0,0,0-.89.89v1.11a.89.89,0,0,0,1.78,0V43.48A.89.89,0,0,0,6.1,42.59Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "corporate-findcompany-1",
    d: "M9.31,40.5H8.2a.89.89,0,1,0,0,1.78H9.31a.89.89,0,0,0,0-1.78Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "corporate-findcompany-1",
    d: "M4,40.49H2.9a.89.89,0,1,0,0,1.78H4a.89.89,0,0,0,0-1.78Z"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFindCompany, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/findCompany.d9aa0986.svg";
export { ForwardRef as ReactComponent };